var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects"},[(!_vm.$can('visit', 'ProjectVersion'))?_c('NotLoggedPanel',{attrs:{"user":_vm.user}}):_vm._e(),(_vm.$can('visit', 'ProjectVersion'))?_c('ProjectVersions',{attrs:{"user":_vm.user}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }